/** Immutable Set updates for React state. */
export const withItem = <T>(s: ReadonlySet<T>, v: T) => new Set(s).add(v);
export function withoutItem<T>(s: ReadonlySet<T>, v: T) {
  const n = new Set(s);
  n.delete(v);
  return n;
}
export const toggleItem = <T>(s: ReadonlySet<T>, v: T) => (s.has(v) ? withoutItem(s, v) : withItem(s, v));
